import { useState } from "react";
import { usePostNousContacter } from "../../../../hooks/NousContacter";
import { Contact } from "../../../../services/Api/swagger";
import ContactForm, { ContactFormData } from "./FormComponent";
import Snack from "../../../../components/Snack";
import Libelle from "../../../../_i18n/fr.json";

function ContactPageForm() {
  const [captchaValue, setCaptchaValue] = useState(undefined);
  const [errorCaptcha, setErrorCaptcha] =
    useState<string | undefined>(undefined);

  const {
    mutate: postNousContacter,
    isLoading: fetchingContact,
    error: errorContact,
    isSuccess: confirmationNousContacter,
    reset,
  } = usePostNousContacter();

  const handleSubmit = (contactForm: ContactFormData) => {
    if (captchaValue) {
      contactForm.response = captchaValue;
      postNousContacter(contactForm);
      if (window.MatomoTagManager) {
        window._paq.push([
          "trackEvent",
          "Envoi formulaire",
          "Clic - CTA",
          "Contact- Envoi formulaire",
        ]);
      }
    } else {
      setErrorCaptcha("Veuillez prouver que vous n'êtes pas un robot");
    }
  };

  const handleCaptchaValue = (value: any) => {
    setCaptchaValue(value);
  };

  return (
    <div id="contact">
      <ContactForm
        onSubmit={handleSubmit}
        fetching={fetchingContact}
        errorCaptcha={errorCaptcha}
        onCaptchaValue={handleCaptchaValue}
      />{" "}
      <Snack
        onClose={reset}
        open={confirmationNousContacter || false}
        variant="success"
        message={Libelle.pageAccueil.confirmFormContact}
      />
    </div>
  );
}

export default ContactPageForm;
